<!-- Custom content projected from outside -->
<!-- optionsTrigger is used even though it looks like it isn't -->
<!-- optionsTrigger is has to be declared in component because of the ngIf statement -->
<ng-container *ngIf="projectedContentTemplate; else defaultContent">
  <div #optionsTrigger="cdkOverlayOrigin" cdkOverlayOrigin>
    <ng-container *ngTemplateOutlet="projectedContentTemplate"></ng-container>
  </div>

  <app-overlay-general
    #optionsListGeneralComponent
    (showChange)="showOverlay$.next($event)"
    [overlayPositions]="optionOverlayPositions"
    [trigger]="optionsTrigger"
  >
    <app-options-list-styled
      (selectedOption)="registerSelectedOption($event)"
      [listItems]="listItems"
      [disabledList]="disabledActionList"
    ></app-options-list-styled>
  </app-overlay-general>
</ng-container>

<!-- Default content if no content projection from outside -->
<ng-template #defaultContent>
  <div
    #defaultOptionsTrigger="cdkOverlayOrigin"
    (click)="optionsListGeneralComponent.toggleShow()"
    [ngClass]="{ opened: showOverlay$ | async, hidden: hideContent }"
    cdkOverlayOrigin
    class="pointer-cursor interaction-list"
  >
    <span class="icon-options"></span>
  </div>

  <app-overlay-general
    #optionsListGeneralComponent
    (showChange)="showOverlay$.next($event)"
    [overlayPositions]="optionOverlayPositions"
    [trigger]="defaultOptionsTrigger"
  >
    <app-options-list-styled
      (selectedOption)="registerSelectedOption($event)"
      [listItems]="listItems"
      [disabledList]="disabledActionList"
    ></app-options-list-styled>
  </app-overlay-general>
</ng-template>
